import { z } from 'zod';
import { idSchema, timestamps } from './utility';

export const debtorSchema = z.object({
  id: idSchema,
  uuid: z.string(),
  ref_id: z.string().nullable(),
  party_type_id: idSchema.nullable(),
  tax_number: z.string().nullable(),
  tax_number_root: z.string().nullable(),
  name: z.string().nullable(),
  long_name: z.string().nullable(),
  debtor_data: z.unknown(),
  ...timestamps,
});
export type Debtor = z.infer<typeof debtorSchema>;
